var map = {
	"./dark/status/32vitalSigns/01more.svg": "1n7V",
	"./light/status/32vitalSigns/01more.svg": "DoWG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/w4/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme ^\.\/.*\/status\/32vitalSigns\/01more\.svg$
// module id = /w4/
// module chunks = 0